<template>
  <div>
    <!-- 
      New
    -->
    <a-modal v-model="isVisible" title="Edit" :maskClosable="false" @ok="onSubmit">
      <div style="overflow-y: scroll; height: 400px; padding-right: 10px">
        Username *
        <a-input v-model="user.email" placeholder="Email" />
        <div style="margin: 10px 0" />
        Name *
        <a-input v-model="user.name" placeholder="" />
        <div style="margin: 10px 0" />
        Role *
        <a-select default-value="Student - Bachelor Degree" v-model="user.type" style="width: 100%">
          <a-select-option value="Admin" v-if="userType === 'Admin' || userType === 'AdminSystem'">
            Admin
          </a-select-option>
          <a-select-option value="Officer"> Officer </a-select-option>
          <a-select-option value="Teacher"> Teacher </a-select-option>
          <a-select-option value="Executive"> Executive </a-select-option>
          <a-select-option value="Student - Bachelor Degree">
            Student - Bachelor Degree
          </a-select-option>
          <a-select-option value="Student - Masters Degree">
            Student - Masters Degree
          </a-select-option>
        </a-select>
        Phone *
        <a-input v-model="user.phone" placeholder="Phone" />
        <div style="margin: 10px 0" />
        Card *
        <a-input v-model="user.card" placeholder="RFID" />
        <div style="margin: 10px 0" />
        Card Expired *
        <a-date-picker v-model="user.cardExpired" @change="onCardExpiredChanged" />
        <div style="margin: 10px 0" />
        Status *
        <a-select default-value="Enable" v-model="user.status" style="width: 100%">
          <a-select-option value="Enable"> Enable </a-select-option>
          <a-select-option value="Disable"> Disable </a-select-option>
        </a-select>
        <div style="margin: 10px 0" />
        Ban *
        <a-select default-value="Enable" v-model="user.ban" style="width: 100%">
          <a-select-option value="Enable"> Enable </a-select-option>
          <a-select-option value="Disable"> Disable </a-select-option>
        </a-select>
        <div style="margin: 10px 0" />
        Ban until
        <a-date-picker v-model="user.banUntil" @change="onBanUntilChanged" />
      </div>
    </a-modal>
    <!-- 
            Data 
        -->
    <a-card :bordered="false" class="header-solid h-full mb-24">
      <!-- Title -->
      <template #title>
        <a-row type="flex" justify="space-between" align="top">
          <a-col :span="12">
            <h5 class="font-semibold m-0">{{ user ? user.email : "" }}</h5>
          </a-col>
          <a-col :span="12" style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            ">
            <a-button type="default" shape="circle" icon="edit" @click="onEdit" />&nbsp;
            <a-button type="danger" shape="circle" icon="delete" @click="onDelete" />
          </a-col>
        </a-row>
      </template>
      <!-- Body -->
      <a-table :columns="columns" :data-source="data" :pagination="false" rowKey="_id">
        <template slot="cardExpired" slot-scope="cardExpired">
          {{ cardExpired !== undefined ? cardExpired.split("T")[0] : "" }}
        </template>
        <template slot="ban" slot-scope="ban">
          <a-tag v-if="ban === 'Enable'" color="green">{{ ban }}</a-tag>
          <a-tag v-if="ban === 'Disable'" color="red">{{ ban }}</a-tag>
        </template>
        <template slot="banUntil" slot-scope="banUntil">
          {{ banUntil !== undefined ? banUntil.split("T")[0] : "" }}
        </template>
        <template slot="status" slot-scope="status">
          <a-tag v-if="status === 'Enable'" color="green">{{ status }}</a-tag>
          <a-tag v-if="status === 'Disable'" color="red">{{ status }}</a-tag>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import notify from "../../utils/notify";

export default {
  props: {},
  components: {},
  data() {
    return {
      data: [],
      columns: [
        {
          title: "Username",
          dataIndex: "email",
          scopedSlots: { customRender: "email" }
        },
        {
          title: "Phone",
          dataIndex: "phone",
          scopedSlots: { customRender: "phone" }
        },
        {
          title: "Card",
          dataIndex: "card",
          scopedSlots: { customRender: "card" }
        },
        {
          title: "Card Expired",
          dataIndex: "cardExpired",
          scopedSlots: { customRender: "cardExpired" }
        },
        {
          title: "Ban",
          dataIndex: "ban",
          scopedSlots: { customRender: "ban" }
        },
        {
          title: "Ban Until",
          dataIndex: "banUntil",
          scopedSlots: { customRender: "banUntil" }
        },
        {
          title: "Status",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
      ],
      //
      userId: localStorage.getItem("id"),
      userRole: localStorage.getItem("role"),
      userType: localStorage.getItem("type"),
      //
      user: {
        _id: "",
        email: "",
        name: "",
        type: "Student - Bachelor Degree",
        phone: "",
        card: "",
        cardExpired: moment().add(1, "Y").format("YYYY-MM-DD"),
        cardExpired: "",
        status: "Enable",
        ban: "Disable",
        banUntil: moment().format("YYYY-MM-DD")
      },
      isVisible: false
    };
  },
  //
  //
  //
  mounted() { },
  methods: {
    //
    //
    //
    setInfo(user) {
      this.user = user;
      this.data.push(user);
    },
    //
    //
    //
    async onCardExpiredChanged(d) {
      this.user.cardExpired = d.format("YYYY-MM-DD");
    },
    async onBanUntilChanged(d) {
      this.user.banUntil = d.format("YYYY-MM-DD");
    },
    //
    // Edit data.
    //
    async onEdit() {
      this.isVisible = true;
      this.id = this.user._id;
      this.email = this.user.email;
      this.name = this.user.name;
      this.type = this.user.type;
      this.phone = this.user.phone;
      this.card = this.user.card;
      this.cardExpired = moment(this.user.cardExpired)
        .add(1, "Y")
        .local()
        .format("YYYY-MM-DD");
      this.ban = this.user.ban;
      this.banUntil = moment(this.user.banUntil).local().format("YYYY-MM-DD");
      this.status = this.user.status;
    },
    //
    //
    //
    async onSubmit() {
      this.isVisible = false;

      // Check require fields
      if (
        this.user.email === "" ||
        this.user.name === "" ||
        this.user.phone === "" ||
        this.user.card === ""
      ) {
        notify.errorNotify(
          this.$notification,
          <a-icon type="close-circle" style="color: #FF0000" />,
          "ใส่ข้อมูลไม่ครบ"
        );
        return;
      }

      //
      axios
        .put(
          process.env.VUE_APP_INVENTORY_API + "/users/" + this.id,
          {
            email: this.user.email,
            name: this.user.name,
            type: this.user.type,
            phone: this.user.phone,
            card: this.user.card,
            cardExpired: this.user.cardExpired,
            status: this.user.status,
            ban: this.user.ban,
            banUntil: this.user.banUntil
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          notify.successNotify(
            this.$notification,
            <a-icon type="check-circle" style="color: #00FF00" />,
            "บันทึกข้อมูลเรียบร้อย"
          );
        })
        .catch(error => {
          notify.errorNotify(
            this.$notification,
            <a-icon type="close-circle" style="color: #FF0000" />,
            error
          );
          return;
        });
    },
    //
    // Delete data.
    //
    onDelete() {
      const self = this;
      this.$confirm({
        title: "ต้องการลบข้อมูลนี้หรือไม่?",
        onOk() {
          self.delete();
        },
        onCancel() { }
      });
    },
    //
    //
    //
    delete() {
      axios
        .delete(process.env.VUE_APP_INVENTORY_API + "/users/" + this.user._id, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          this.$router.push("/users");
        })
        .catch(error => {
          notify.errorNotify(
            this.$notification,
            <a-icon type="close-circle" style="color: #FF0000" />,
            error
          );
          return;
        });
    }
  }
};
</script>

<style lang="scss">
.ant-calendar-picker {
  width: 100%;
}

table>tbody>tr {
  vertical-align: top;
}
</style>
